import React, { Component } from "react"
import Scrollable from "@cirrus/legacy/app-components/scrollable/scrollable/index.jsx"

import styles from "./styles.less"

export default class SidebarFilter extends Component {
  render() {
    return (
      <Scrollable className={styles.sidebarFilter}>
        <div className={styles.filterContainer}>{this.props.children}</div>
      </Scrollable>
    )
  }
}
